<template>
    <span
        class="inline-flex items-center justify-center rounded-xl shrink-0"
        :class="[sizeClass, toneClass]"
    >
        <component :is="icon" :size="iconSize" :weight="weight" />
    </span>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { ConceptTone } from '@/design/icons';

type IconBadgeSize = 'sm' | 'md' | 'lg';

const props = withDefaults(
    defineProps<{
        icon: Component;
        tone?: ConceptTone;
        size?: IconBadgeSize;
        weight?: string;
    }>(),
    {
        tone: 'primary',
        size: 'md',
        weight: 'fill',
    },
);

const SIZE_CLASSES: Record<IconBadgeSize, string> = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
};

const ICON_SIZES: Record<IconBadgeSize, number> = {
    sm: 18,
    md: 22,
    lg: 24,
};

const TONE_CLASSES: Record<ConceptTone, string> = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    error: 'bg-error/10 text-error',
    neutral: 'bg-base-200 text-base-content/60',
};

const sizeClass = computed(() => SIZE_CLASSES[props.size]);
const iconSize = computed(() => ICON_SIZES[props.size]);
const toneClass = computed(() => TONE_CLASSES[props.tone]);
</script>
